export default __webpack_public_path__ + "images/EA.50e0f85.png";